// extracted by mini-css-extract-plugin
module.exports = {"SCSS_GREEN_COLOR":"\"green\""};